import "./credits.scss";
import { useContext, useState, useRef, useEffect } from "react";
import { credits } from "../../services/api";


const Credits = () => {
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [creditsCount, setCreditsCount] = useState(0);

    const fetchCredits = async () => {
        try {
          const response = await credits();
          // Assuming response.data contains tenantName and credits
          setCreditsCount(response.data.total_credits);
          setLoading(false);
        } catch (err) {
          console.error("Error fetching credits:", err);
          setError('Failed to load tenant information.');
          setLoading(false);
        } finally {
          setLoading(false);
        }
      };
      useEffect(() => {
        // Initial fetch when the component mounts
        fetchCredits();
    
        // Set up the interval to fetch credits every 5 minutes (300,000 ms)
        const intervalId = setInterval(() => {
          fetchCredits();
        }, 300000); // 300,000 ms = 5 minutes
    
        // Cleanup function to clear the interval when the component unmounts
        return () => clearInterval(intervalId);
      }, []);


    if (isLoading) return(
        <div className="credits">
            Credits:
            <div className="totalCredits">?</div>
        </div>
        );
    if (error) return 
        <div className="credits">
            Credits:
            <div className="totalCredits">{error.message}</div>
        </div>;

    return (
        <div className="credits">
           Credits:
           <div className="totalCredits" style={{color: "white", background: "green"}}>{creditsCount}</div>
        </div>
    );
}

export default Credits;